import React, {Fragment, useEffect, useState} from "react"
import PropTypes from "prop-types"
import {Button, Col, Form, Input, Label, Row,} from "reactstrap"
// Toastify
import {ToastContainer, toast} from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import {Slide} from "react-toastify"
import APIS from "../../apis"
import {withTranslation} from "react-i18next"
import Select from "react-select"

const AddOrientation = props => {
    var userAuthEnseignant = JSON.parse(
        localStorage.getItem("userAuthEtudiant")
    )
    var etudiant_id = userAuthEnseignant.user.id
    var departement_id = userAuthEnseignant.user.departement_id
    var annee_id = userAuthEnseignant.user.annee_id

    const [etat, setEtat] = useState(0)
    const [moyenCartographie, setMoyenCartographie] = useState("")
    const [specialiteGeo, setSpecialiteGeo] = useState([])
    const [selectSpecialiteGeo, setSelectSpecialiteGeo] = useState("")
    const [moyenGeneraleHistoire, setMoyenGeneraleHistoire] = useState("")
    const [sessionHistoire, setSessionHistoire] = useState([])
    const [selectSessionHistoire, setSelectSessionHistoire] = useState("")
    const [moyenHistoire, setMoyenHistoire] = useState("")
    const [moyenHistoire1, setMoyenHistoire1] = useState("")
    const [moyenHistoire2, setMoyenHistoire2] = useState("")
    const [moyenHistoire3, setMoyenHistoire3] = useState("")
    const [moyenAnnuelleAng, setMoyenAnnuelleAng] = useState("")
    const [moyenAnnuelleSocio, setMoyenAnnuelleSocio] = useState("")
    const [moyenAnnuelleGeo, setMoyenAnnuelleGeo] = useState("")
    const [specialiteAng, setSpecialiteAng] = useState([])
    const [selectSpecialiteAng, setSelectSpecialiteAng] = useState("")
    const [sessionAng, setSessionAng] = useState([])
    const [selectSessionAng, setSelectSessionAng] = useState("")
    useEffect(async () => {
        const res = await APIS.post("geo/listform", {
            departement_id
        }).then(res => {
            setSpecialiteGeo(res.data.geo)
        })
        const resAng = await APIS.post("geo/listform", {
            departement_id
        }).then(resAng => {
            setSpecialiteAng(resAng.data.geo)
        })
        const resSessionHistoire = await APIS.post("histoire/getsession",{departement_id}).then(resSessionHistoire => {
            setSessionHistoire(resSessionHistoire.data.session)
        })
        const resSessionAng = await APIS.post("histoire/getsession",{departement_id}).then(resSessionAng => {
            setSessionAng(resSessionAng.data.session)
        })
    }, [])
    const save = async () => {
        var etat = true
        if (selectSessionHistoire === "") {
            etat = false
            toast.error("⛔ الدورة ضروري", {
                containerId: "A",
            })
        } else  if (moyenAnnuelleGeo === "") {
            etat = false
            toast.error("⛔ معدل النجاح بالسنة الأولى ضروري", {
                containerId: "A",
            })
        } else  if (selectSessionHistoire === "") {
            etat = false
            toast.error("⛔ معدل النجاح بالسنة الأولى ضروري", {
                containerId: "A",
            })
        } else if (moyenCartographie === "") {
            etat = false
            toast.error("⛔ معدل وحدة الخرائطية بالسنة الأولى ضروري", {
                containerId: "A",
            })
        } else if (selectSpecialiteGeo === "") {
            etat = false
            toast.error("⛔ على الطالب إختيار أحد المسالك التالية ضروري", {
                containerId: "A",
            })
        }
        if (etat) {
            const res = await APIS.post("geo/store", {
                etudiant_id,
                moyenne_mp: moyenCartographie,
                spectialite: selectSpecialiteGeo.value,
                moyenne_premiere_annee: moyenAnnuelleGeo,
                session_id:selectSessionHistoire.value,
                annee_id,
            })
            if (res.data.msg === "demande add  successfully") {
                toast.success(" Demande orientation est ajouté avec succées ", {
                    containerId: "A",
                })
                props.setSection(1)
            }
        }
    }
    const saveHistoire = async () => {
        var etat = true
        if (moyenGeneraleHistoire === "") {
            etat = false
            toast.error("⛔ معدل النجاح بالسنة الأولى ضروري ", {
                containerId: "A",
            })
        } else if (selectSessionHistoire === "") {
            etat = false
            toast.error("⛔ الدورة ضروري ", {
                containerId: "A",
            })
        } else if (moyenHistoire === "") {
            etat = false
            toast.error("⛔ معدل التاريخ القديم ضروري ", {
                containerId: "A",
            })
        } else if (moyenHistoire1 === "") {
            etat = false
            toast.error("⛔ معدل التاريخ الوسيط ضروري ", {
                containerId: "A",
            })
        } else if (moyenHistoire2 === "") {
            etat = false
            toast.error("⛔ معدل التاريخ الحديث ضروري ", {
                containerId: "A",
            })
        } else if (moyenHistoire3 === "") {
            etat = false
            toast.error("⛔ معدل التاريخ المعاصر ضروري ", {
                containerId: "A",
            })
        } else if (selectSpecialiteGeo === "") {
            etat = false
            toast.error("⛔ المسالك ضروري ", {
                containerId: "A",
            })
        }
        if (etat) {
            const res = await APIS.post("histoire/store", {
                etudiant_id,
                moyenne_mp1: moyenHistoire,
                moyenne_mp2: moyenHistoire1,
                moyenne_mp3: moyenHistoire2,
                moyenne_mp4: moyenHistoire3,
                moyenne_premiere_annee: moyenGeneraleHistoire,
                session_id: selectSessionHistoire.value,
                spectialite: selectSpecialiteGeo.value,
                annee_id,
            })
            if (res.data.msg === "demande add  successfully") {
                toast.success(" Demande orientation est ajouté avec succées ", {
                    containerId: "A",
                })
                props.setSection(1)
            }
        }
    }
    const saveAng = async () => {
        var etat = true;
        if (moyenAnnuelleAng === "") {
            etat = false;
            toast.error("⛔ Moyenne Annuelle en 1ère Année est obligatoire", {
                containerId: "A",
            });
        } else if (selectSessionAng === "") {
            etat = false;
            toast.error("⛔ Admis Session est obligatoire", {
                containerId: "A",
            });
        } else if (selectSpecialiteGeo === "") {
            etat = false;
            toast.error("⛔ 1er Choix de Spécialité est obligatoire", {
                containerId: "A",
            });
        } else if (selectSpecialiteAng === "") {
            etat = false;
            toast.error("⛔ 2ème Choix de Spécialité est obligatoire", {
                containerId: "A",
            });
        }
        if (selectSpecialiteGeo.value === selectSpecialiteAng.value) {
            etat = false;
            toast.error("⛔ Les deux spécialités ne doivent pas être identiques.", {
                containerId: "A",
            });
        }
        if (etat) {
            const res = await APIS.post("anglais/store", {
                etudiant_id,
                moyenne_premiere_annee: moyenAnnuelleAng,
                choi1_spectialite: selectSpecialiteGeo.value,
                choi2_spectialite: selectSpecialiteAng.value,
                session_id: selectSessionAng.value,
                annee_id,
            });
            if (res.data.msg === "demande add  successfully") {
                toast.success("Demande orientation est ajoutée avec succès", {
                    containerId: "A",
                });
                props.setSection(1);
            }
        }
    };
    const saveSociologie = async () => {
        var etat = true;
        if (selectSessionHistoire === "") {
            etat = false;
            toast.error("⛔ الدورة ضروري", {
                containerId: "A",
            });
        }  else if (moyenAnnuelleAng === "") {
            etat = false;
            toast.error("⛔ معدل النجاح بالسنة الأولى ضروري", {
                containerId: "A",
            });
        }  else if (selectSpecialiteGeo === "") {
            etat = false;
            toast.error("⛔ الإختيار الأول  لأحد المسالك ضروري", {
                containerId: "A",
            });
        } else if (selectSpecialiteAng === "") {
            etat = false;
            toast.error("⛔ الإختيار الثاني  لأحد المسالك ضروري", {
                containerId: "A",
            });
        }
        if (selectSpecialiteGeo.value === selectSpecialiteAng.value) {
            etat = false;
            toast.error("⛔ Les deux spécialités ne doivent pas être identiques.", {
                containerId: "A",
            });
        }
        if (etat) {
            const res = await APIS.post("sociologie/store", {
                etudiant_id,
                moyenne_premiere_annee: moyenAnnuelleAng,
                choi1_spectialite: selectSpecialiteGeo.value,
                choi2_spectialite: selectSpecialiteAng.value,
                session_id:selectSessionHistoire.value,
                annee_id,
            });
            if (res.data.msg === "demande add  successfully") {
                toast.success("Demande orientation est ajoutée avec succès", {
                    containerId: "A",
                });
                props.setSection(1);
            }
        }
    };

    const getSpecialteGeo = async event => {
        setSelectSpecialiteGeo(event)
        APIS.post(
            "parametrage/getetat",
            {
                annee_id: annee_id
            }
        ).then(resEtat => {
            setEtat(resEtat.data.etat)
        })
    }
    const getSpecialteAng = async event => {
        setSelectSpecialiteAng(event)
        APIS.post(
            "parametrage/getetat",
            {
                annee_id: annee_id
            }
        ).then(resEtat => {
            setEtat(resEtat.data.etat)
        })
    }
    return (
        <React.Fragment>
            {departement_id === 164 ? (
                <Row>
                    <Form>
                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                    <span style={{direction: "ltr"}}>

                                    </span>
                                        <span style={{direction: "rtl"}}>
                                      الدورة :
                                    </span>
                                    </Label>

                                    <Select
                                        options={sessionHistoire}
                                        isSearchable={true}
                                        onChange={e => setSelectSessionHistoire(e)}
                                        value={selectSessionHistoire}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                    <span style={{direction: "ltr"}}>
                                    </span>
                                        <span style={{direction: "rtl"}}>
                                            معدل النجاح بالسنة الأولى :
                                    </span>
                                    </Label>
                                    <Input
                                        lg="3"
                                        type="number"
                                        className="form-control"
                                        placeholder={props.t("معدل النجاح بالسنة الأولى")}
                                        onChange={e => setMoyenAnnuelleGeo(e.target.value)}
                                    />
                                </div>
                            </Col>

                        </Row>
                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                    <span style={{direction: "ltr"}}>
                                    </span>
                                        <span style={{direction: "rtl"}}>
                                      معدل وحدة الخرائطية بالسنة الأولى :
                                    </span>
                                    </Label>
                                    <Input
                                        lg="3"
                                        type="text"
                                        className="form-control"
                                        placeholder={props.t("معدل وحدة الخرائطية بالسنة الأولى")}
                                        onChange={e => setMoyenCartographie(e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                    <span style={{direction: "ltr"}}>
                                    </span>
                                        <span style={{direction: "rtl"}}>
                                      على الطالب إختيار أحد المسالك التالية :
                                    </span>
                                    </Label>

                                    <Select
                                        options={specialiteGeo}
                                        isSearchable={true}
                                        onChange={e => getSpecialteGeo(e)}
                                        value={selectSpecialiteGeo}
                                    />
                                </div>
                            </Col>

                        </Row>

                        <div style={{display: "flex", justifyContent: "center"}}>
                            {" "}
                            <Col lg="6">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                    }}
                                    className="text-center mt-4"
                                >
                                    <Button
                                        type="button"
                                        color="warning"
                                        className="btn btn-warning  mb-2 me-2"
                                        onClick={props.back}
                                    >
                                        {props.t("Annuler")}
                                    </Button>
                                </div>
                            </Col>

                            <Col lg="6">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                    }}
                                    className="text-center mt-4"
                                >
                                    {etat === 1 ? (
                                        <button
                                            type="button"
                                            className="btn btn-primary "
                                            onClick={save}
                                        >
                                            {props.t("Confirmer")}
                                        </button>
                                    ) : null}
                                </div>
                            </Col>


                        </div>

                    </Form>
                </Row>
            ) : departement_id === 165 ? (
                <Row>
                    <Form>
                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                    <span style={{direction: "ltr"}}>

                                    </span>
                                        <span style={{direction: "rtl"}}>
                                      معدل النجاح بالسنة الأولى :
                                    </span>
                                    </Label>
                                    <Input
                                        lg="3"
                                        type="number"
                                        className="form-control"
                                        placeholder={props.t("معدل النجاح بالسنة الأولى")}
                                        onChange={e => setMoyenGeneraleHistoire(e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                    <span style={{direction: "ltr"}}>

                                    </span>
                                        <span style={{direction: "rtl"}}>
                                      الدورة :
                                    </span>
                                    </Label>

                                    <Select
                                        options={sessionHistoire}
                                        isSearchable={true}
                                        onChange={e => setSelectSessionHistoire(e)}
                                        value={selectSessionHistoire}
                                    />
                                </div>
                            </Col>

                        </Row>
                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                        <span style={{direction: "ltr"}}>

                                        </span>
                                        <span style={{direction: "rtl"}}>
                                      معدل التاريخ القديم :
                                    </span>
                                    </Label>
                                    <Input
                                        lg="3"
                                        type="number"
                                        className="form-control"
                                        placeholder={props.t("معدل التاريخ القديم")}
                                        onChange={e => setMoyenHistoire(e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                        <span style={{direction: "ltr"}}>

                                        </span>
                                        <span style={{direction: "rtl"}}>
                                      معدل التاريخ الوسيط :
                                    </span>
                                    </Label>
                                    <Input
                                        lg="3"
                                        type="number"
                                        className="form-control"
                                        placeholder={props.t("معدل التاريخ الوسيط")}
                                        onChange={e => setMoyenHistoire1(e.target.value)}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                        <span style={{direction: "ltr"}}>

                                        </span>
                                        <span style={{direction: "rtl"}}>
                                      معدل التاريخ الحديث :
                                    </span>
                                    </Label>
                                    <Input
                                        lg="3"
                                        type="number"
                                        className="form-control"
                                        placeholder={props.t("معدل التاريخ الحديث")}
                                        onChange={e => setMoyenHistoire2(e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                        <span style={{direction: "ltr"}}>

                                        </span>
                                        <span style={{direction: "rtl"}}>
                                      معدل التاريخ المعاصر :
                                    </span>
                                    </Label>
                                    <Input
                                        lg="3"
                                        type="number"
                                        className="form-control"
                                        placeholder={props.t("معدل التاريخ المعاصر")}
                                        onChange={e => setMoyenHistoire3(e.target.value)}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                    <span style={{direction: "ltr"}}>

                                    </span>
                                        <span style={{direction: "rtl"}}>
                                      على الطالب إختيار أحد المسالك التالية :
                                    </span>
                                    </Label>

                                    <Select
                                        options={specialiteGeo}
                                        isSearchable={true}
                                        onChange={e => getSpecialteGeo(e)}
                                        value={selectSpecialiteGeo}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <div style={{display: "flex", justifyContent: "center"}}>
                            {" "}
                            <Col lg="6">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                    }}
                                    className="text-center mt-4"
                                >
                                    <Button
                                        type="button"
                                        color="warning"
                                        className="btn btn-warning  mb-2 me-2"
                                        onClick={props.back}
                                    >
                                        {props.t("Annuler")}
                                    </Button>
                                </div>
                            </Col>

                            <Col lg="6">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                    }}
                                    className="text-center mt-4"
                                >
                                    {etat === 1 ? (
                                        <button
                                            type="button"
                                            className="btn btn-primary "
                                            onClick={saveHistoire}
                                        >
                                            {props.t("Confirmer")}
                                        </button>
                                    ) : null}
                                </div>
                            </Col>


                        </div>

                    </Form>
                </Row>
            ) : departement_id === 162 ? (
                <Row>
                    <Form>
                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                    <span style={{direction: "ltr"}}>
                                      {"Moyenne Annuelle en 1ère Année :"}
                                    </span>
                                        <span style={{direction: "rtl"}}>

                                    </span>
                                    </Label>
                                    <Input
                                        lg="3"
                                        type="number"
                                        className="form-control"
                                        placeholder={props.t("Moyenne Annuelle en 1ère Année")}
                                        onChange={e => setMoyenAnnuelleAng(e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                    <span style={{direction: "ltr"}}>
                                            Admis Session:
                                    </span>
                                        <span style={{direction: "rtl"}}>
                                    </span>
                                    </Label>
                                    <Select
                                        options={sessionAng}
                                        isSearchable={true}
                                        onChange={e => setSelectSessionAng(e)}
                                        value={selectSessionAng}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                    <span style={{direction: "ltr"}}>
                                      {"1er Choix de Spécialité :"}
                                    </span>
                                        <span style={{direction: "rtl"}}>
                                    </span>
                                    </Label>
                                    <Select
                                        options={specialiteGeo}
                                        isSearchable={true}
                                        onChange={e => setSelectSpecialiteGeo(e)}
                                        value={selectSpecialiteGeo}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                    <span style={{direction: "ltr"}}>
                                      {"2ème Choix de Spécialité :"}
                                    </span>
                                        <span style={{direction: "rtl"}}>
                                    </span>
                                    </Label>
                                    <Select
                                        options={specialiteAng}
                                        isSearchable={true}
                                        onChange={e => getSpecialteAng(e)}
                                        value={selectSpecialiteAng}
                                    />
                                </div>
                            </Col>

                        </Row>
                        <div style={{display: "flex", justifyContent: "center"}}>
                            {" "}
                            <Col lg="6">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                    }}
                                    className="text-center mt-4"
                                >
                                    <Button
                                        type="button"
                                        color="warning"
                                        className="btn btn-warning  mb-2 me-2"
                                        onClick={props.back}
                                    >
                                        {props.t("Annuler")}
                                    </Button>
                                </div>
                            </Col>

                            <Col lg="6">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                    }}
                                    className="text-center mt-4"
                                >
                                    {etat === 1 ? (
                                        <button
                                            type="button"
                                            className="btn btn-primary "
                                            onClick={saveAng}
                                        >
                                            {props.t("Confirmer")}
                                        </button>
                                    ) : null}
                                </div>
                            </Col>


                        </div>
                    </Form>
                </Row>
            ) : departement_id === 166 ? (
                <Row>
                    <Form>
                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                    <span style={{direction: "ltr"}}>

                                    </span>
                                        <span style={{direction: "rtl"}}>
                                      الدورة :
                                    </span>
                                    </Label>

                                    <Select
                                        options={sessionHistoire}
                                        isSearchable={true}
                                        onChange={e => setSelectSessionHistoire(e)}
                                        value={selectSessionHistoire}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                    <span style={{direction: "ltr"}}>
                                    </span>
                                        <span style={{direction: "rtl"}}>
                                            معدل النجاح بالسنة الأولى :
                                    </span>
                                    </Label>
                                    <Input
                                        lg="3"
                                        type="number"
                                        className="form-control"
                                        placeholder={props.t("معدل النجاح بالسنة الأولى")}
                                        onChange={e => setMoyenAnnuelleAng(e.target.value)}
                                    />
                                </div>
                            </Col>

                        </Row>
                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                    <span style={{direction: "ltr"}}>
                                    </span>
                                        <span style={{direction: "rtl"}}>
                                            الإختيار الأول  لأحد المسالك :
                                    </span>
                                    </Label>
                                    <Select
                                        options={specialiteGeo}
                                        isSearchable={true}
                                        onChange={e => setSelectSpecialiteGeo(e)}
                                        value={selectSpecialiteGeo}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label htmlFor="basicpill-firstname-input1"
                                           style={{display: "flex", justifyContent: "space-between"}}>
                                    <span style={{direction: "ltr"}}>
                                    </span>
                                        <span style={{direction: "rtl"}}>
                                            الإختيار الثاني  لأحد المسالك :
                                    </span>
                                    </Label>
                                    <Select
                                        options={specialiteAng}
                                        isSearchable={true}
                                        onChange={e => getSpecialteAng(e)}
                                        value={selectSpecialiteAng}
                                    />
                                </div>
                            </Col>

                        </Row>
                        <div style={{display: "flex", justifyContent: "center"}}>
                            {" "}
                            <Col lg="6">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                    }}
                                    className="text-center mt-4"
                                >
                                    <Button
                                        type="button"
                                        color="warning"
                                        className="btn btn-warning  mb-2 me-2"
                                        onClick={props.back}
                                    >
                                        {props.t("Annuler")}
                                    </Button>
                                </div>
                            </Col>

                            <Col lg="6">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                    }}
                                    className="text-center mt-4"
                                >
                                    {etat === 1 ? (
                                        <button
                                            type="button"
                                            className="btn btn-primary "
                                            onClick={saveSociologie}
                                        >
                                            {props.t("Confirmer")}
                                        </button>
                                    ) : null}
                                </div>
                            </Col>


                        </div>
                    </Form>
                </Row>
            ):null}

            <ToastContainer
                transition={Slide}
                enableMultiContainer
                containerId={"A"}
                position={toast.POSITION.TOP_RIGHT}
                autoClose={2500}
            />
        </React.Fragment>
    )
}

export default withTranslation()(AddOrientation)
AddOrientation.propTypes = {
    history: PropTypes.object,
    back: PropTypes.object,
    setSection: PropTypes.object,
    t: PropTypes.any,
}
